import store from "../../store/store";
import Participant from "../../entities/participant";
import {uuid} from "../../@types/schema";

/**
 * Get all relationships for this id.
 * The id could belong to a contact, lead or matter.
 *
 * @param {uuid} entityId
 * @returns {Participant[]}
 */
export function getParticipants(entityId: uuid): Participant[] {
    /** @type {Participant[]} */
    return store.getState().participants.getMappingFor('entityId', entityId);
}